module.exports = __webpack_public_path__ + "r-v3/img/set_general.b7e30cae.svg";